import EventNotifier from "../utils/event-notifier";
const GeneratorEvents = {
    onPreviewingPackageChange: new EventNotifier(),
    onPackagePreviewReadyChange: new EventNotifier(),
    onFileDataChange: new EventNotifier(),
    onGlobalSettingsChange: new EventNotifier(),
};
export default GeneratorEvents;
